module.exports = __webpack_public_path__ + "static/grundge-042675f5202a053f62089225fcc7453b.png";